import { useState, useCallback } from 'react'
import Toast from './Toast'

let toastId = 0

const ToastContainer = () => {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback((message, type) => {
    const id = toastId++
    setToasts((prev) => [...prev, { id, message, type }].slice(-3))
  }, [])

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  // Expose addToast globally
  window.showToast = addToast

  return (
    <div className='toast-container'>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  )
}

export default ToastContainer

// button examples
// <button onClick={() => window.showToast('Info message', 'info')}>
//   Show Info
// </button>
// <button onClick={() => window.showToast('Success!', 'success')}>
//   Show Success
// </button>
// <button
//   onClick={() => window.showToast('Something went wrong', 'error')}
// >
//   Show Error
// </button>
// <button onClick={() => window.showToast('Warning!', 'warning')}>
//   Show Warning
// </button>
